import React, { useEffect, useState } from "react";
import { axios } from "../../../../Global";
import Overview from "./ProjectSections/Overview";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import { checkAccessFn } from "../../../../utils/checkAccess";

export const capitalize = (str) =>
  str.replace(/^(.)|\s+(.)/g, (c) => c.toUpperCase());
export default function ProjectSingleView() {
  const { projectId } = useParams();
  const token = localStorage.getItem("token");
  const [updateData, setUpdateData] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allSections = [
    "overview",
    // "contract",
    "job-enquiry",
    "rec-agency",
    // "job-order",
    // "candidate-list",
    // "vendors",
    // "Quotation Costsheet",
    // "Client",
    // "Company",
    // "Notes",
    // "More",
  ];

  const [currentSection, setCurrentSection] = useState("overview");

  useEffect(() => {
    setCurrentSection(location.pathname.split("/").at(4) || "overview");
  }, [location.pathname]);

  console.log(
    "Routing can be seen here in console",
    location.pathname.split("/").at(4),
    currentSection
  );

  const [projectDetails, setProjectDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [overviewLoading, setOverviewLoading] = useState(true);

  // To rerender the component when the project is updated
  const [projectUpdated, setProjectUpdated] = useState(false);
  const [jobEnquiryUpdated, setJobEnquiryUpdated] = useState(false);
  const toggleProjectUpdate = () => setProjectUpdated((prev) => !prev);
  const toggleJobEnquiryUpdate = () => setJobEnquiryUpdated((prev) => !prev);
  const [updateSingleProject, setUpdateSingleProject] = useState(false);
  const [JobEnquiryInputValue, setJobEnquiryInputValue] = useState();

  const fetchJobEnquiry = async () => {
    console.log("get here");
    setLoading(true);
    try {
      const res = await axios.get(
        `/dashboard/project-job-enquiry-module/${projectId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.status == 200) {
        setJobEnquiryInputValue(res?.data?.data);
        setLoading(false);
      }
    } catch (error) {
      dispatch(setAppError({ msg: error.message }));
      setLoading(false);
    }
  };

  useEffect(() => {
    axios
      .get(`/dashboard/project/${projectId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setLoading(false);
        setOverviewLoading(false);
        const data = res.data.data;
        setProjectDetails(data);
      })
      .catch((err) => {
        setLoading(false);
        setOverviewLoading(false);
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      });
  }, [projectUpdated, updateSingleProject]);

  useEffect(() => {
    if (currentSection == "job-enquiry") {
      fetchJobEnquiry();
    }
  }, [jobEnquiryUpdated, currentSection]);

  //settings breadcrumb
  useEffect(() => {
    dispatch(
      setBreadCrumb([
        { label: "PROJECT", link: "/dashboard/project" },
        {
          label: String(
            projectDetails?.project?.project_id || "..."
          ).toUpperCase(),
          // link: `/dashboard/project/${projectDetails?.id}`,
        },
      ])
    );
  }, [projectDetails]);

  const updateDeleteVendor = (type, id, status) => {
    const updatedProjectDetails = { ...projectDetails };
    if (type === "status") {
      const vendorIndex =
        updatedProjectDetails.project.project_vendor.findIndex(
          (vendor) => vendor.id === id
        );

      if (vendorIndex !== -1) {
        updatedProjectDetails.project.project_vendor[vendorIndex].status =
          status;
        setProjectDetails(updatedProjectDetails);
      }
    } else if (type === "delete") {
      updatedProjectDetails.project.project_vendor =
        updatedProjectDetails.project.project_vendor.filter(
          (vendor) => vendor.id !== id
        );

      setProjectDetails(updatedProjectDetails);
    }
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  if (
    currentSection === "contract" &&
    !checkAccess("Contract", "contract-list")
  )
    setCurrentSection("overview");
  if (
    currentSection === "vendors" &&
    !checkAccess("Project", "project-vendor-list")
  )
    setCurrentSection("overview");
  if (
    currentSection === "job-enquiry" &&
    !checkAccess("Project", "project-job-enquiry-list")
  )
    setCurrentSection("overview");

  const navButtons = [
    {
      id: 1,
      name: "overview",
      url: "",
    },
    {
      id: 2,
      name: "job-enquiry",
      url: "job-enquiry",
      checkAccessMain: "Project",
      checkAccessSub: "project-job-enquiry-list",
    },
    {
      id: 3,
      name: "rec-agency",
      url: "rec-agency",
      checkAccessMain: "Project",
    },
    {
      id: 4,
      name: "job-order",
      url: "job-order",
      checkAccessMain: "Project",
      // disabled: true,
    },
    {
      id: 5,
      name: "candidate-list",
      url: "candidate-list",
      checkAccessMain: "Project",
      // disabled: true,
    },
  ];

  return (
    <>
      {/* Tab Navigation */}
      <div className="w-full bg-white border-b border-slate-200 px-4 flex flex-wrap gap-1 pt-2">
        {navButtons.map((btn) => {
          const hasAccess = btn.checkAccessMain && btn.checkAccessSub
            ? checkAccess(btn.checkAccessMain, btn.checkAccessSub)
            : true;

          if (!hasAccess) return null;

          const isActive = currentSection === btn.name;
          return (
            <button
              key={btn.id}
              disabled={btn?.disabled}
              onClick={() => {
                setCurrentSection(btn.name);
                if (btn.url !== "") navigate(btn.url);
              }}
              className={`px-4 py-2 rounded-t-md font-medium uppercase transition-colors ${
                isActive
                  ? "bg-red text-white"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              } ${btn?.disabled ? "opacity-40 cursor-not-allowed" : ""}`}
            >
              {capitalize(btn?.name?.split("-").join(" "))}
            </button>
          );
        })}
      </div>

      {/* Loading */}
      {loading && (
        <div className="flex justify-center items-center gap-3 py-12">
          <CgSpinner className="animate-spin text-2xl text-slate-500" />
          <p className="text-slate-500">Loading...</p>
        </div>
      )}

      {/* Content */}
      {!loading && (
        <div className="w-full">
          {currentSection === "overview" && !overviewLoading && (
            <div className="p-4">
              <Overview
                projectDetails={projectDetails?.project}
                projectTypeArray={projectDetails?.quotation_type}
                reportingManagerArray={projectDetails?.reporting_manager}
                projectCoordinatorArray={projectDetails?.project_coordinator}
                toggleProjectUpdate={toggleProjectUpdate}
              />
            </div>
          )}
          {currentSection === "job-enquiry" && checkAccess("Project", "project-job-enquiry-list") && (
            <Outlet context={[JobEnquiryInputValue, toggleJobEnquiryUpdate, projectDetails]} />
          )}
          {currentSection === "rec-agency" && checkAccess("Project", "project-job-enquiry-list") && (
            <Outlet context={[JobEnquiryInputValue, toggleJobEnquiryUpdate, projectDetails]} />
          )}
          {currentSection === "job-order" && checkAccess("Project", "project-job-enquiry-list") && (
            <Outlet context={[projectDetails]} />
          )}
          {currentSection === "candidate-list" && checkAccess("Project", "project-job-enquiry-list") && (
            <Outlet context={[projectDetails]} />
          )}
        </div>
      )}
    </>
  );
}
